import { Component, OnInit } from '@angular/core';
import { BookService } from 'src/app/shared/book.service';

declare let alertify : any;
declare let localforage : any;
declare let window : any;

@Component({
	selector: 'app-quiz-categories',
	templateUrl: './quiz-categories.component.html',
	styleUrls: ['./quiz-categories.component.css']
})
export class QuizCategoriesComponent implements OnInit {
	listBook! : any[];
	constructor(private service : BookService) { }

	ngOnInit() : void {
		var booksOnline = this.service.getBooks();
		var products : any = (booksOnline as any).default;
		var listItem = [];
		for (const property in products) {
			listItem.push(products[property]);
		}
		this.listBook = listItem.map((item, index) => {
			//var urlIm = this.imageProcessKeyword(item.code, '');
			return {
				code: item.code,
				label: item.label,
				desc: item.desc,
				background: window.__static + `/static/${item.code}/image/background_stretch.png`,
				//url: window.__static + `/static/${item.code}/image/avatar.png`,
				url: window['__cdn_static'] + `${item.code}/image/avatar.png`,
				//url:urlIm,
			};
		});
	}

	getCdnImage(url : string) {
		let s = url || '';
		let fix = 'http://static.bilet.vn/static/';
		if (s.length > fix.length)
			s = window['__cdn_static'] + s.substr(fix.length);
		console.log(s);
		return s;
	}

	imageProcessKeyword(filename : string, sourcefolder : string) {
		var lowerfilename = filename;
		lowerfilename = lowerfilename.toLocaleLowerCase();

		var newfilename = lowerfilename;
		if (newfilename.indexOf(" ") >= 0) {
			newfilename = newfilename.replace(/ /g, "_");
		} else if (filename.indexOf("/") >= 0) {
			newfilename = filename.replace("/", "-");
		} else if (filename.indexOf("'") >= 0) {
			newfilename = filename.replace("'", "_");
		}

		//var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
		var url = window['__cdn_static'] + `${sourcefolder}${newfilename}.png`;
		return url;
	}

}